import type { IntlShape } from 'react-intl';

export function getRatingDesc(intl: IntlShape, value: number): string {
  const descriptions = [
    '',
    intl.formatMessage({ id: 'evaluation.rating.1' }, { defaultMessage: '非常不满意' }),
    intl.formatMessage({ id: 'evaluation.rating.2' }, { defaultMessage: '不满意' }),
    intl.formatMessage({ id: 'evaluation.rating.3' }, { defaultMessage: '一般' }),
    intl.formatMessage({ id: 'evaluation.rating.4' }, { defaultMessage: '满意' }),
    intl.formatMessage({ id: 'evaluation.rating.5' }, { defaultMessage: '非常满意' }),
  ];
  return descriptions[value] || '';
}


